import { Stack } from '@mui/material'
import { WaitingServicesList } from './waiting-services-list'
import { ServicesList } from './services-list'
import { PageHeader } from '@/components'

export function AdditionalServicesPage() {
  return (
    <>
      <PageHeader>Serviços adicionais</PageHeader>
      <Stack spacing={2}>
        <WaitingServicesList />
        <ServicesList />
      </Stack>
    </>
  )
}
